module.exports = __webpack_public_path__ + "img/dlybg03.4d4baa73.png";